<script setup lang="ts">
import type {HoverTooltipState} from '@/components/assistant/composables/useAssistantMessageChart'

defineProps<{
  tooltip: HoverTooltipState
  containerClass: string
  titleClass: string
  valueClass: string
}>()
</script>

<template>
  <div
    v-if="tooltip.show"
    class="pointer-events-none absolute z-20 rounded-md border px-2 py-1 text-[11px] shadow-lg"
    :class="containerClass"
    :style="{left: `${tooltip.x}px`, top: `${tooltip.y}px`}"
  >
    <div class="font-semibold" :class="titleClass">{{ tooltip.title }}</div>
    <div :class="valueClass">{{ tooltip.value }}</div>
  </div>
</template>
